export const PLANS = {
    free: {
        name: 'free',
        label: 'Free',
        price: 0,
        invoicesPerMonth: 50,
        retentionDays: 93,
        retentionLabel: '3 months',
        features: [
            'Up to 50 invoices/orders per month',
            'All 31+ predefined templates',
            'Full access to AI Copilot',
            'Standard PDF downloads & printing',
            'Standard document suite (Invoices, Packing Slips, Receipts)',
            '3-month secure invoice retention'
        ],
        gatedFeatures: {
            delivery: false,
            automation: false,
            pos: false,
            bulkExportExcel: false,
            bulkExportLimit: 50,
            taxOverride: false,
            multiLanguage: false,
            ublXml: false,
            ftpSync: false,
            googleDriveSync: false,
            multiCurrencyDual: false,
            threeDecimalPrecision: false,
            localizedSequentialNumbering: false,
            b2bDocuments: false,
            epcQrCodes: false,
            shippingLabels: false
        }
    },
    starter: {
        name: 'starter',
        label: 'Starter',
        price: 9.99,
        invoicesPerMonth: -1,
        retentionDays: 93 * 4,
        retentionLabel: '1 year',
        features: [
            'Unlimited invoices & orders',
            'Automated PDF delivery via email',
            'Full access to hybrid editor & AI Copilot',
            'Shopify POS & barcode integration',
            'Shopify Flow integration (triggers & actions)',
            'UBL XML / PEPPOL & ZUGFeRD exports (E-invoicing compliance)',
            '1-year secure invoice retention'
        ],
        gatedFeatures: {
            delivery: true,
            automation: true,
            pos: true,
            bulkExportExcel: true,
            bulkExportLimit: -1,
            taxOverride: false,
            multiLanguage: false,
            ublXml: true,
            ftpSync: false,
            googleDriveSync: false,
            multiCurrencyDual: false,
            threeDecimalPrecision: false,
            localizedSequentialNumbering: false,
            b2bDocuments: false,
            epcQrCodes: true,
            shippingLabels: false
        }
    },
    professional: {
        name: 'professional',
        label: 'Professional',
        price: 29.99,
        invoicesPerMonth: -1,
        retentionDays: 93 * 28,
        retentionLabel: '7 years',
        features: [
            'All Starter features, plus:',
            'Location-based prefixes & custom sequential numbering',
            'Custom tax overrides (VAT / GST per product & SKU)',
            'Auto-translated emails & localized PDF attachments',
            'Proformas, B2B Quotes, and Credit Notes',
            '3-decimal unit precision & multi-currency displays',
            'Automated backups to FTP or Google Drive',
            'Shopify Flow triggers & actions',
            'Advanced AI logic for conditional layouts',
            'UBL XML & ZUGFeRD exports (E-invoicing compliance)',
            'EPC QR codes for instant mobile POS payments',
            'GLS Shipping Labels for EEU',
            '7-year compliance tax retention'
        ],
        gatedFeatures: {
            delivery: true,
            automation: true,
            pos: true,
            bulkExportExcel: true,
            bulkExportLimit: -1,
            taxOverride: true,
            multiLanguage: true,
            ublXml: true,
            ftpSync: true,
            googleDriveSync: true,
            multiCurrencyDual: true,
            threeDecimalPrecision: true,
            localizedSequentialNumbering: true,
            b2bDocuments: true,
            epcQrCodes: true,
            shippingLabels: true
        }
    }
};

// Keep enterprise as alias for professional for legacy code references
PLANS.enterprise = PLANS.professional;

export function getPlan(subscription) {
    return PLANS[subscription] || PLANS.free;
}

export function getPlanPrice(planName) {
    const plan = PLANS[planName];
    return plan ? plan.price : 0;
}

export function canUseFeature(subscription, feature) {
    const plan = getPlan(subscription);
    return plan.gatedFeatures[feature] || false;
}

export function getRetentionDays(subscription) {
    const plan = getPlan(subscription);
    return plan.retentionDays;
}

export function getMonthlyInvoiceLimit(subscription) {
    const plan = getPlan(subscription);
    return plan.invoicesPerMonth;
}

export default PLANS;



// WEBPACK FOOTER //
// config/pricing.js